/* @flow */

import moment from 'moment';

export default class CommissionMembership {
  // data
  isoCompany: string;
  isoOffice: string;
  isoPerson: string;
  sellerCompany: string;
  revenueDate: moment;
  membershipFeeCouponReference: string;
  membershipFeeCouponAmountUsed: number;
  membershipFee: number;
  membershipCommission: number;

  // filters
  filterISOId: number;
  filterISOOfficeId: number;
  filterISOPersonId: number;
  filterPeriod: moment;
}
